export function loadClzsChart(myChart, obj) {
  console.log(obj);
  // var name = ["二化螟", "稻纵卷叶螟", "粉蝶灯蛾"];
  // var data = [
  //   [181.55, 198.35, 114.02, 179.55, 189.57, 156.14],
  //   [251.55, 298.35, 254.02, 279.55, 288.57, 258.14],
  //   [381.55, 398.35, 314.02, 379.55, 389.57, 356.14],
  //   [451.55, 498.35, 454.02, 479.55, 488.57, 458.14],
  //   [581.55, 598.35, 514.02, 579.55, 589.57, 556.14],
  //   [651.55, 698.35, 654.02, 679.55, 688.57, 658.14]
  // ];
  var name = [];
  var data = [];
  var time = [];
  for (let i in obj) {
    name.push(obj[i].name);
    data.push(obj[i].data);
    time.push(obj[i].time);
  }
  name = [...new Set(name)];
  time = [...new Set(time)];
  var dataVal = [];
  for (let i in name) {
    var numArr = [];
    for (let k in obj) {
      if (name[i] == obj[k].name) {
        numArr.push(obj[k].number);
      }
    }
    dataVal.push(numArr);
  }
  var color = [
    "#0e9cff",
    "#03cdf8",
    "#f77400",
    "#eac600",
    "#fff0FF",
    "#f0B50F"
  ];
  var dataValue = [];
  for (let i in name) {
    dataValue.push({
      name: name[i],
      type: "line",
      smooth: true, //是否平滑
      showAllSymbol: true,
      // symbol: 'image://./static/images/guang-circle.png',
      symbol: "circle",
      symbolSize: 5,
      lineStyle: {
        normal: {
          color: color[i],
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 5,
          shadowOffsetX: 5
        }
      },
      label: {
        show: false,
        position: "top",
        textStyle: {
          color: "#fff",
          fontSize: 10
        }
      },
      itemStyle: {
        color: color[i],
        borderColor: "rgb(0,115,100)",
        borderWidth: 0,
        shadowColor: "rgba(0, 0, 0, 0)",
        shadowBlur: 0,
        shadowOffsetY: 0,
        shadowOffsetX: 0
      },
      tooltip: {
        show: true
      },
      data: dataVal[i]
    });
  }
  myChart.setOption({
    legend: {
      show: true,
      icon: "circle",
      orient: "horizontal",
      top: "2%",
      right: "2%",
      itemWidth: 10,
      itemHeight: 8,
      itemGap: 5,
      textStyle: {
        // color: '#FFFFFF'
        color: "#fff",
        fontSize: 10
      }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(0, 255, 233,0)"
              },
              {
                offset: 0.5,
                color: "rgba(255, 255, 255,1)"
              },
              {
                offset: 1,
                color: "rgba(0, 255, 233,0)"
              }
            ],
            global: false
          }
        }
      }
    },
    grid: {
      top: "18%",
      left: "0%",
      right: "5%",
      bottom: "5%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        splitArea: {
          // show: true,
          color: "#f00",
          lineStyle: {
            color: "#f00"
          }
        },
        axisLabel: {
          color: "#fff"
        },
        boundaryGap: false,
        data: time,
        splitLine: {
          lineStyle: {
            color: "rgba(255,255,255,.5)",
            width: 1,
            type: "dashed"
          },
          show: true
        },
        axisLine: {
          lineStyle: {
            color: "rgba(255,255,255,.5)",
            width: 1,
            type: "solid"
          },
          show: true
        }
      }
    ],

    yAxis: [
      {
        type: "value",
        min: 0,
        // max: 140,
        splitNumber: 4,
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#fff"],
            opacity: 0.06
          }
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true,
          margin: 20,
          textStyle: {
            fontSize: 10,
            color: "rgba(255,255,255,1)"
          }
        },
        axisTick: {
          show: false
        }
      }
    ],
    series: dataValue
  });
}
